import * as React from 'react';
import * as formatters from '~/lib/formatters';
import { Overlay, PopupModal } from '~/common/layout/Modals';


export default (props) => {
  const { transaction, onClose, location } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  // TODO: Fix me - use proper data from the transaction
  return (
    <Overlay onClick={handleClose}>
      <PopupModal>
        <div className="invoice__head">
          <span className="invoice__head__logo">
            <img src="/assets/img/placeholder/logo-inline.svg" alt=""/>
          </span>
          <span className="invoice__head__text">Receipt</span>
        </div>

        <div className="col__cont modal--invoice__content">
          <div className="col__row col--invoice">
            <div className="col col--3">
              <div className="grid__inn">
                <img className="grid__logo" src="/assets/img/placeholder/capstone.png" alt="" />
                <div className="grid__row">
                  <span className="grid__label">EIN:</span>
                  <span className="grid__value">39-5928539</span>
                </div>
              </div>
            </div>
            <div className="col col--3">
              <div className="grid__inn">
                <span className="grid__label">Amount Due</span>
                <span className="grid__amount">${formatters.currency(transaction.amount)}</span>
                {transaction.receiptUrl && <a href={transaction.receiptUrl} className="btn btn--sm btn--prim btn--tag">Paid in full</a>}
              </div>
            </div>
            <div className="col col--3">
              <div className="grid__inn">
                <div className="grid__inline">
                  <span className="grid__label">Date</span>
                  <span className="grid__value">{formatters.date(transaction.date)}</span>
                </div>
                <div className="grid__inline">
                  <span className="grid__label">Receipt #</span>
                  <span className="grid__value">22042</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col__row">
            <div className="col col--6">
              <div className="grid__inn--fw">

                <div className="grid__fw">
                  <span className="grid__label">location</span>
                  <span className="grid__value">{location.name}</span>
                </div>

                <div className="grid__inn">
                  <span className="grid__label">Items</span>

                  <div className="grid__row__inline">
                    <span className="grid__value">Pallets</span>
                    <span className="grid__value">$15.66</span>
                  </div>
                  <div className="grid__row__inline">
                    <span className="grid__value">Pallets</span>
                    <span className="grid__value">$15.66</span>
                  </div>
                  <div className="grid__row__inline">
                    <span className="grid__value">Pallets</span>
                    <span className="grid__value">$15.66</span>
                  </div>
                  <div className="grid__row__inline">
                    <span className="grid__value">Pallets</span>
                    <span className="grid__value">$15.66</span>
                  </div>
                  <div className="grid__row__inline">
                    <span className="grid__value">Pallets</span>
                    <span className="grid__value">$15.66</span>
                  </div>
                  <div className="grid__row__inline">
                    <span className="grid__value">Pallets</span>
                    <span className="grid__value">$15.66</span>
                  </div>
                  <div className="grid__row__inline">
                    <span className="grid__value">Pallets</span>
                    <span className="grid__value">$15.66</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col col--6">
              <div className="grid__inn">
                <div className="grid__inline">
                  <span className="grid__label">PO #</span>
                  <span className="grid__value">389467</span>
                  <span className="grid__value">389467</span>
                  <span className="grid__value">389467</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col__row modal--invoice__foot">
          <div className="modal--invoice__btns">
            <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Download</a>
            <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Print</a>
            <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Email</a>
            <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Text</a>
          </div>

          <div className="input input--outl">
            <label className="input__label input__label--inline">Link:</label>
            <input placeholder="Click to copy..." value="relay.link/4f3321" />
          </div>
        </div>
      </PopupModal>
    </Overlay>
  );
};
